import React from 'react'

const StarIcon = () => (
	<svg width="16" height="18" viewBox="0 1 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M8.71308 1.19384C8.48883 0.503094 7.51158 0.503094 7.28658 1.19384L6.14733 4.69934C6.09826 4.84983 6.00284 4.98094 5.87472 5.07389C5.74660 5.16685 5.59236 5.21689 5.43408 5.21684H1.74858C1.02258 5.21684 0.719577 6.14684 1.30758 6.57434L4.28958 8.74034C4.41767 8.83347 4.513 8.96474 4.56191 9.11537C4.61081 9.266 4.61079 9.42824 4.56183 9.57884L3.42333 13.0843C3.19833 13.7751 3.98958 14.3503 4.57683 13.9228L7.55883 11.7568C7.68699 11.6637 7.84137 11.6135 7.99983 11.6135C8.15828 11.6135 8.31266 11.6637 8.44083 11.7568L11.4228 13.9228C12.0101 14.3503 12.8013 13.7758 12.5763 13.0843L11.4378 9.57884C11.3889 9.42824 11.3888 9.266 11.4377 9.11537C11.4867 8.96474 11.582 8.83347 11.7101 8.74034L14.6921 6.57434C15.2793 6.14684 14.9778 5.21684 14.2511 5.21684H10.5648C10.4067 5.21673 10.2526 5.16662 10.1246 5.07367C9.99667 4.98073 9.90136 4.84971 9.85233 4.69934L8.71308 1.19384Z"
			stroke="#A0A0A0"
			fill="white"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

const SubTabMenu = ({
	tabType,
	subSelectedTab,
	onSubTabChange,
	counts,
	categoryClassName,
	activeClassName,
}) => {
	const SUB_TAB_CONFIG = {
		received: [
			{ value: 'all', label: '전체', count: counts.receivedAllCount },
			{ value: 'pending', label: '대기중', count: counts.receivedPendingCount },
			{ value: 'negotiating', label: '협상중', count: counts.receivedNegotiatingCount },
			// { value: 'liked', label: '관심', hasIcon: true },
		],
		sent: [
			{ value: 'all', label: '전체', count: counts.sentAllCount },
			{ value: 'pending', label: '대기중', count: counts.sentPendingCount },
			{ value: 'negotiating', label: '협상중', count: counts.sentNegotiatingCount },
			// { value: 'liked', label: '관심', hasIcon: true },
		],
		past: [
			{ value: 'all', label: '전체', count: counts.pastAllCount },
			// { value: 'liked', label: '관심', hasIcon: true },
		],
	}

	const tabs = SUB_TAB_CONFIG[tabType] || []

	return (
		<div className={categoryClassName || 'contract-item-category'}>
			{tabs.map((tab) => (
				<div
					key={tab.value}
					className={
						subSelectedTab === tab.value
							? tab.hasIcon
								? `${activeClassName || 'active'} liked_tab`
								: activeClassName || 'active'
							: tab.hasIcon
								? 'liked_tab'
								: ''
					}
					onClick={() => onSubTabChange(tab.value)}>
					{tab.hasIcon ? (
						<>
							<div>{tab.label}</div>
							<div>
								<StarIcon />
							</div>
						</>
					) : (
						`${tab.label} ${tab.count}`
					)}
				</div>
			))}
		</div>
	)
}

export default SubTabMenu
